/*
 * jk-home-poster (7.11, track H, 2026-09-28).
 * 1. Header handoff: while the poster's own navigation row is on screen the
 *    site header stays hidden (CSS in sections/jk-home-poster.liquid). Once the
 *    row has scrolled off the top, body gets .jk-hp-past and the header slides in.
 * 2. Cart count: mirrors the header's count, which the theme updates after
 *    AJAX cart changes, into the poster's "Cart (n)".
 * 3. Exit (7.24, see the block at the end).
 */
(function () {
  const poster = document.querySelector('.jk-hp');
  if (!poster) return;

  if (poster.hasAttribute('data-hide-header')) {
    const nav = poster.querySelector('.jk-hp__nav') || poster;
    const setPast = (past) => document.body.classList.toggle('jk-hp-past', past);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        const e = entries[entries.length - 1];
        setPast(!e.isIntersecting && e.boundingClientRect.bottom <= 0);
      });
      io.observe(nav);
    } else {
      setPast(true);
    }
  }

  const source = document.querySelector('#cart-drawer-toggle .thb-item-count');
  const target = poster.querySelector('[data-jk-hp-count]');
  if (source && target) {
    const sync = () => {
      const n = source.textContent.trim();
      if (/^\d+$/.test(n)) target.textContent = n;
      else if (source.querySelector('svg')) target.textContent = '99+';
    };
    new MutationObserver(sync).observe(source, { childList: true, characterData: true, subtree: true });
  }

  /* 3. Exit (7.24, Dan, 2026-10-12: "when you're transitioning off of the home page ... slide down and out
   *    of the frame first. And then ... the elements on the top ... except for our logo and the mood
   *    background image"). On a phone, a tap on a poster link that leaves the homepage first clears the
   *    poster: the drop stack at the bottom (button, drop name, character name) slides down out of the
   *    frame, the button leading by a hair, and from 0.15 s 15% OFF lifts out the top while the hub row
   *    slips up into a slot under the logo (cut at its own top edge, so it never crosses the logo).
   *    The logo, the photo and the grain never move. Then the page changes (0.39 s after the tap, never
   *    later than 0.6 s), and the existing logo glide (snippets/jk-view-transition.liquid) carries the
   *    logo into the next page's header.
   *    - The next page is prefetched from the moment the finger lands, so the network works during the
   *      slide and the wait mostly hides inside it.
   *    - Taking the click here (before the document-level listeners) also means the old "bar forms at the
   *      tap" step (G4) stands down: the slide is the tap's answer now, and the glide grows the bar itself.
   *    - Skipped for: Cmd/Ctrl/Shift/Alt or middle clicks, new-tab and download links, other sites, links
   *      a script already handled (Search, Cart, 15% OFF, Shelf are buttons or drawers), the same page,
   *      a poster that is scrolled away, tablets and desktop, and "Reduce motion" (plain navigation).
   *    - The piece that was tapped (a hub name, the drop name or the button) does not move: it turns
   *      orange (hub names keep their underline) and stays until the next page takes over, so the
   *      page change is not held back for it. Pieces above a held button or drop name slip down
   *      behind it instead of crossing it.
   *    - Back/forward: the browser may restore this page from memory exactly as it was left (slid out), so
   *      on pageshow everything is put back at once. A second tap while leaving is ignored. If the page is
   *      still here 8 s later (navigation stopped or failed), it is put back too. */
  const EXIT_PHONE = '(max-width: 767px)';
  const calm = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: true };
  const EASE = 'cubic-bezier(.35, .1, .8, .35)';
  let leaving = null;
  const shown = (el) => { const r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; };
  const pick = (sel) => Array.prototype.filter.call(poster.querySelectorAll(sel), shown);
  const targetOf = (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a || !poster.contains(a)) return null;
    if ((a.target && a.target !== '_self') || a.hasAttribute('download')) return null;
    let to;
    try { to = new URL(a.href, location.href); } catch (err) { return null; }
    if (to.origin !== location.origin || /^(mailto|tel|javascript):/.test(to.protocol)) return null;
    if (to.pathname === location.pathname && to.search === location.search) return null;
    return to;
  };
  const prefetched = new Set();
  const prefetch = (to) => {
    const href = to.href.split('#')[0];
    if (prefetched.has(href)) return;
    prefetched.add(href);
    try {
      if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
        const s = document.createElement('script');
        s.type = 'speculationrules';
        s.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [href] }] });
        document.head.appendChild(s);
      } else {
        const l = document.createElement('link');
        l.rel = 'prefetch';
        l.href = href;
        document.head.appendChild(l);
      }
    } catch (err) {}
  };
  const reset = () => {
    if (!leaving) return;
    clearTimeout(leaving.go);
    clearTimeout(leaving.undo);
    leaving.anims.forEach((x) => { try { x.cancel(); } catch (err) {} });
    poster.querySelectorAll('.is-picked').forEach((x) => x.classList.remove('is-picked'));
    poster.classList.remove('is-leaving');
    leaving = null;
  };
  const canExit = () => !calm.matches && matchMedia(EXIT_PHONE).matches && !!Element.prototype.animate
    && !document.body.classList.contains('jk-hp-past');
  poster.addEventListener('pointerdown', (e) => {
    if (e.button || !canExit()) return;
    const to = targetOf(e);
    if (to) prefetch(to);
  }, { passive: true });
  poster.addEventListener('click', (e) => {
    if (leaving) { e.preventDefault(); return; }
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || !canExit()) return;
    const to = targetOf(e);
    if (!to) return;
    /* the piece the shopper tapped stays put (Dan, 2026-10-12: "don't slide out the element you clicked
       on ... just keep it there"), marked as picked, and leaves with the page itself */
    const link = e.target.closest('a[href]');
    const held = link.closest('.jk-hp__links li, .jk-hp__drop-btn, .jk-hp__line--bottom');
    const stack = pick('.jk-hp__drop-btn, .jk-hp__line--bottom, .jk-hp__drop-m').filter((el) => el !== held);
    const items = pick('.jk-hp__links li').filter((el) => el !== held);
    const util = pick('.jk-hp__util');
    if (!stack.length && !items.length && !util.length) return;
    e.preventDefault();
    prefetch(to);
    const vh = window.innerHeight;
    const anims = [];
    let end = 0;
    /* cut: a fixed line on screen (px from the top) the piece disappears into as it moves, so it never
       crosses the logo or the held piece. The clip runs in step with the slide (both follow the same
       eased progress), so the cut line stays still. */
    const slide = (el, y, duration, delay, cut) => {
      end = Math.max(end, duration + delay);
      y = Math.round(y);
      let frames = [{ translate: '0 0' }, { translate: `0 ${y}px` }];
      if (cut != null) {
        const r = el.getBoundingClientRect();
        const s0 = y < 0 ? Math.min(0, cut - r.top) : Math.max(0, cut - r.bottom);
        const k = Math.min(1, Math.max(0, s0 / y || 0));
        const side = (v) => (y < 0 ? `inset(${v}px 0px 0px 0px)` : `inset(0px 0px ${v}px 0px)`);
        frames = [{ translate: '0 0', clipPath: side(0) }];
        if (k > 0) frames.push({ offset: k, translate: `0 ${Math.round(s0)}px`, clipPath: side(0) });
        frames.push({ translate: `0 ${y}px`, clipPath: side(Math.abs(Math.round(y - s0))) });
      }
      anims.push(el.animate(frames, { id: 'jk-hp-exit', duration, delay, easing: EASE, fill: 'forwards' }));
    };
    if (stack.length) {
      /* one distance for the whole stack, so it leaves as a unit; lowest piece first. Pieces above a held
         button or drop name slip down behind it instead of crossing it. */
      const hr = held && !held.closest('.jk-hp__links') ? held.getBoundingClientRect() : null;
      const rects = stack.map((el) => el.getBoundingClientRect());
      const dy = vh - Math.min(...rects.map((r) => r.top)) + 16;
      stack.map((el, i) => [el, rects[i]]).sort((p, q) => q[1].top - p[1].top)
        .forEach(([el, r], i) => slide(el, dy, 300, i * 30, hr && r.bottom <= hr.top + 1 ? hr.top - 2 : null));
    }
    /* the hub items slip up into a slot at the row's top edge, under the logo */
    items.forEach((el) => { const r = el.getBoundingClientRect(); slide(el, -(r.height + 2), 220, 150, r.top); });
    util.forEach((el) => slide(el, -(el.getBoundingClientRect().bottom + 16), 240, 150));
    link.classList.add('is-picked');
    poster.classList.add('is-leaving');
    leaving = {
      anims,
      go: setTimeout(() => { location.assign(to.href); }, Math.min(end, 600)),
      undo: setTimeout(reset, 8000)
    };
  });
  window.addEventListener('pageshow', reset);
})();
